
function SubjectSkelaton() {
  return (
    <div className="animate-pulse bg-neutral-400 rounded-xl h-full w-full min-h-[200px] min-w-[217px]"></div>
  )
}

export default SubjectSkelaton